<template>
  <div >
    <!-- Short dispatch -->
    <modal
      :title="$t('OrderCurrent.actions.shortDispatch')"
      @close-request="reinitializeModal();"
      closable
      >
      <table-element
      :title="$t('OrderCurrent.modal.selected_orders')"
      :fields="fieldsObj"
      :arrOfElement="arrOfOrder"
      :sortSpacing="3"
      :isShowFilter="false"
      class="card mx-2 mt-4"
      :isDraggable="true"
      @updateFinalData="updateFinalData"
      >
    
        <template #header-actions>
          <p class="text-center red-text"><i class="fa fa-exclamation mr-2" /><i>{{$t('OrderCurrent.modal.short_dispatch.process_tooltip')}}</i></p>
          <p class="mb-0 mt-3 mx-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
        </template>

        <template #pre-body-content>
          <regular-datalist-driver
            key="driver"
            :value="dispatchOrder.chauffeurName"
            @input="onDriverInput"
            :secondList="liste"
            :placeholder="$t('OrderInfo.modal.driver') + '*'" class="form-group border m-2"/>
            <div v-if="selectedDriverType === 'Sous-traitant'" class="d-flex flex-wrap m-2 align-items-center">
                <label for="discount" class="mr-2"><strong>Discount(%): </strong></label>
                <regular-input-number
                  min="0"
                  :value="selectedDiscount"
                  @input="selectedDiscount = $event; applyDiscount()"
                  type="number" :placeholder="$t('OrderInfo.modal.price')"/>
            </div>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <!-- :key="'order' + index"> -->
          <tr v-for="(order, index) in content.results"
          class="table-element_hover text-center draggable-item"
          :id="'order' + index"
          :key="order.orderNumber">
            <td><i class="mx-2 fa fa-solid fa-bars drag-handle" /></td>
            <td v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </td>
            <td v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order); setFeedbackMessage('')"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </td>
            <td>
              <button class="btn btn-kne-orange" @click="onChangeAddress(order)"><i class="fas fa-edit" /> {{$t('DeliveryLocationModal.address_button')}}</button>
            </td>
            <td v-if="isOrderNbClickable">
              <strong
                  @click="onOrderNumberView()">
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </td>
            <td v-else>
              {{order.orderNumber}}
            </td>
            <td>
                <regular-select
              :placeholder="$t('StatusChangeModal.select_placeholder')"
              :value="order.deliveryType || ''"
              @change="onDeliveryTypeSelect($event, order)"
              >
                <option
                  v-for="status in deliveryTypeOptions"
                  :value="status.value"
                  :key="status.label"
                  :class="status.class">
                    <p>{{status.label}}</p>
                </option>
            </regular-select>
            </td>
            <td>
              <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                <hover-tool-tip
                  :text="`${order.transmitterAddress}
                          ${order.transmitterCity},
                          ${order.transmitterProvince}
                          ${order.transmitterPostcode},
                          ${order.transmitterCountry}`"
                  :top="true"
                  :right="true"
                  :clickable="true"
                />
              </span>
            </td>
            <td>
              <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                <hover-tool-tip
                  :text="`${order.receiverAddress}
                          ${order.receiverCity},
                          ${order.receiverProvince}
                          ${order.receiverPostcode},
                          ${order.receiverCountry}`"
                  :top="true"
                  :left="true"
                  clickable
                />
              </span>
            </td>
            <td>
              <regular-input-number
              v-show="!isBrunoAccount"
              min="0"
              :class="'mb-2 short-dispatch-price-field'"
              :value="order.price"
              @input="order.price = $event; applyCustomerDiscount(order)"
              type="number" :placeholder="$t('OrderInfo.modal.price')"/>
              <regular-input-number
              v-show="isBrunoAccount"
              :id="'price' + order.orderNumber"
              min="0"
              :class="'mb-2 short-dispatch-price-field'"
              :value="order.price"
              @input="order.price = $event; applyCustomerDiscount(order)"
              type="number" :placeholder="(order.recommendedMaxPrice) + '$ Max'"/>
              <span v-if="order.customerDiscount && order.customerDiscount !== undefined" class="mt-2 text-warning">
                Discount Applied: {{ order.customerDiscount }}
              </span>
              <span v-if="isBrunoAccount && (Number(order.recommendedMaxPrice) < Number(order.price))" class="mt-2 text-danger">{{ $t('ShortDispatch.recommended_max_price') + ': ' + order.recommendedMaxPrice + '$' }}</span>
            </td>
            <td>
              <regular-input
              min="0"
              :value="order.numRef"
              @input="order.numRef = $event"
              type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
            </td>
            <td>
              <regular-input
              :value="order.comment"
              @input="order.comment = $event"
              type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(order, index) in content.results"
          class="card my-3 mx-2 draggable-item"
          :key="order.orderNumber">
            <div class="card-header">
              <h4 v-if="isOrderNbClickable">
                <strong
                @click="onOrderNumberView()">
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </h4>
            <h4 v-else>
              {{order.orderNumber}}
            </h4>

              <div id="action" class="float-left">
                <p v-if="checkHistory(order.historySync)" class=""> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </p>
                <p v-else class=""> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </p>
                <button class="btn btn-kne-orange mx-1" @click="onChangeAddress(order)"><i class="fas fa-edit" /> {{$t('DeliveryLocationModal.address_button')}}</button>
              </div>
            </div>

            <div>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                  <hover-tool-tip
                    :text="`${order.transmitterAddress}
                            ${order.transmitterCity},
                            ${order.transmitterProvince}
                            ${order.transmitterPostcode},
                            ${order.transmitterCountry}`"
                    :top="true"
                    :right="true"
                    :clickable="true"
                  />
                </span>
              </p>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                  <hover-tool-tip
                    :text="`${order.receiverAddress}
                            ${order.receiverCity},
                            ${order.receiverProvince}
                            ${order.receiverPostcode},
                            ${order.receiverCountry}`"
                    :top="true"
                    :left="true"
                    clickable
                  />
                </span>
              </p>
              <div class="m-2">

                <regular-select
                :placeholder="$t('StatusChangeModal.select_placeholder')"
                :value="order.deliveryType || ''"
                @change="onDeliveryTypeSelect($event, order)"
                >
                  <option
                    v-for="status in deliveryTypeOptions"
                    :value="status.value"
                    :key="status.label"
                    :class="status.class">
                      <p>{{status.label}}</p>
                  </option>
              </regular-select>
              </div>
              <p class="m-2">
                <regular-input
                v-show="!isBrunoAccount"
                min="0"
                class="short-dispatch-price-field"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')"/>

                <regular-input
                v-show="isBrunoAccount"
                :id="'price' + order.orderNumber"
                min="0"
                class="short-dispatch-price-field"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="order.recommendedMaxPrice + '$ Max'"/>
              </p>
              <p class="m-2">
                <regular-input
                min="0"
                :value="order.numRef"
                @input="order.numRef = $event; "
                type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
              </p>
              <p class="m-2">
                <regular-input
                :value="order.comment"
                @input="order.comment = $event"
                type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
              </p>
              <div class="d-flex justify-content-center my-3">
                <i class="mx-2 fa fa-solid fa-bars drag-handle" />
              </div>
            </div>
          </div>
          
        </template>

        <template #post-body-content>
          <div class="mt-2">
            <p class="red-text mb-0 mx-1 text-right">{{ feedbackMessage }}</p>
            <button
              class="float-right btn btn-kne-orange m-1"
              @click="onShortDispatchActionConfirm()">
              {{$t('OrderCurrent.modal.confirm')}}
            </button>
            <button @click="reinitializeModal()" class="float-right btn btn-danger m-1">{{$t('OrderCurrent.modal.cancel')}}</button>
          </div>
        </template>
      </table-element>

      <loading-render v-if="isLoading" />
    </modal>

    <!-- Distributed History -->
    <distributed-history-modal
      key="distributed"
      ref="distModal"
      :isOpen="isDistributedModal"
      :priceOrderLink="priceOrderLink"
      @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
      @closeModal="isDistributedModal = false"
      @onOrderModification="onOrderModification"
    />

    <!-- Delivery Location -->
    <delivery-location-modal
      ref="delivLocDetails"
      :addressbook="addressbook"
      :showBilling="false"
      :isOpen="isDelivLocModal"
      :isFromDispatch="true"
      @emitNewOrderLocation="updateOrderLocation"
      @closeModal="isDelivLocModal = false"
    />
    <gmap-map id="map" :zoom="8" :center="{ lat: 45.4215, lng: -75.6972 }" />
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import Modal from '../../interface-components/Modal.vue'
import regularSelect from '../../../module/basic-components/regularSelect.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import DistributedHistoryModal from './DistributedHistory-modal.vue'
import DeliveryLocationModal from './DeliveryLocation-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'
import { db } from '../../../../firebase'
import { publishOrderSyncRequest } from '../../../../odoo-sync-requests/order'

export default {
  name: 'ShortDispatchModal',
  components: {
    Modal,
    regularInput,
    regularSelect,
    regularInputNumber,
    regularDatalistDriver,
    hoverToolTip,
    DistributedHistoryModal,
    DeliveryLocationModal,
    TableElement,
    LoadingRender
  },

  props: {
    arrOfOrder: {
      type: Array,
      required: true
    },
    liste: {
      type: Array,
      required: true
    },
    addressbook: {
      type: Array,
      required: true
    },
    priceOrderLink: {
      type: Array,
      required: true
    },
    isOrderNbClickable: {
      type: Boolean,
      required: false
    },
    isOpen: Boolean
  },

  data () {
    return {
      // Keep a copy of the initial data passed to the child. This will be updated in child component using updateFinalData()
      finalData: this.arrOfOrder.slice().reverse(),
      dispatchOrder: {
        chauffeurUid: '',
        chauffeurName: ''
      },
      selectedDriverType: '',
      selectedDiscount: 20,
      feedbackMessage: '',
      isDelivLocModal: false,
      isDistributedModal: false,
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
        text: this.$t('OrderInfo.modal.deliveryType'),
        type: 'deliveryType',
        value: ''
       },
       {
         text: this.$t('OrderInfo.modal.pickup.title'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.delivery.title'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxescomment'),
         type: 'comment',
         value: ''
       }
      ],
      selectedDeliveryType: '',
      deliveryTypeOptions: [
        {label: `${this.$t('OrderInfo.delivery.delivery')}`, value: 'delivery'},
        {label: `${this.$t('OrderInfo.delivery.return')}`, value: 'return'}
      ]
    }
  },

  async created () {
    this.isLoading = false
    // Add default delivery type for each order
    this.finalData = this.arrOfOrder.slice().reverse().map(item => {
      item.deliveryType = 'delivery'
      return item
    })
    this.finalData.forEach(async order => {
      this.initializeOrderPricing(order)
      if (!order.distance) {
        order.distance = await this.calculateTravelDistance(order)
      }
      this.applyCustomerDiscount(order)
    })
  },

  methods: {
    onDriverInput (driver) {
      this.dispatchOrder.chauffeurName = driver.value
      this.dispatchOrder.chauffeurUid = driver.key
      this.setFeedbackMessage('')
      this.checkChauferType(driver)
    },
    isValueDefined (value) {
      return value !== undefined && value !== null && value !== ''
    },

    getPriceValue (entry) {
      if (!entry || typeof entry !== 'object') return 0

      if (this.isValueDefined(entry.price)) return Number(entry.price) || 0
      if (this.isValueDefined(entry.prix)) return Number(entry.prix) || 0

      return 0
    },

    async processOrders (orders) {
    this.isLoading = false
    this.finalData = orders.slice().reverse().map(item => {
      item.deliveryType = 'delivery'
      return item
    })

    for (const order of orders) {
      this.initializeOrderPricing(order)
      if (!order.distance) {
        order.distance = await this.calculateTravelDistance(order)
      }
    }
  },
    updateFinalData (newData) {
      this.finalData = [...newData]
    },
    initializeOrderPricing (order) {
      const maxInputPrice = this.calculateMaxInputPrice(order)
      order.recommendedMaxPrice = maxInputPrice

      if (this.shouldAutofillDispatchPrice(order)) {
        order.price = maxInputPrice
      }
    },
    shouldAutofillDispatchPrice (order) {
      const orderNumber = order.orderNumber || order['.key']
      const currentOrder = this.priceOrderLink.find(obj => obj.orderId === orderNumber)
      const basePrice = Number(currentOrder && currentOrder.price != null ? currentOrder.price : order.price)
      const currentPrice = Number(order.price)

      if (order.price === '' || order.price === null || typeof order.price === 'undefined') {
        return true
      }

      if (isNaN(currentPrice)) return true
      return currentPrice === basePrice
    },
    reCalculateRecommendedPrice () {
      for (const order of this.arrOfOrder) {
        this.initializeOrderPricing(order)
      }
    },
    checkChauferType (event) {
      if (event.key) {
        db.ref('userInfos').child(this.companyUID).child(event.key).once('value', (snapshot) => {
          if (!snapshot.exists()) return
          let driverData = snapshot.val()
          this.selectedDriverType = driverData.role
          if (this.selectedDriverType === 'Sous-traitant' || driverData.role === 'Sous-traitant') {
            this.applyDiscount()
          }
        })
      }
    },
    applyCustomerDiscount (order) {
      if (order.customerDiscount) {
        const discounts = order.customerDiscount.split(' ')
        const customerDiscount = {
          discountCategory: discounts[0],        // "-" or "+"
          discountAmount: Number(discounts[1]),  // numeric value
          discountAmountType: discounts[2]       // "%" or "$"
        }

        let originalPrice = Number(order.price)
        let discount = 0
        let surplus = 0

        if (customerDiscount.discountCategory === '-') {
          if (customerDiscount.discountAmountType === '$') {
            discount = customerDiscount.discountAmount
          } else {
            discount = (originalPrice * customerDiscount.discountAmount) / 100
          }
        } else if (customerDiscount.discountCategory === '+') {
          if (customerDiscount.discountAmountType === '$') {
            surplus = customerDiscount.discountAmount
          } else {
            surplus = (originalPrice * customerDiscount.discountAmount) / 100
          }
        }

        discount = isNaN(discount) ? 0 : discount
        surplus = isNaN(surplus) ? 0 : surplus

        let discountedPrice = ((originalPrice - discount + surplus).toFixed(2))
        order.price = discountedPrice
      }
    },
    applyDiscount () {
      this.arrOfOrder.forEach(order => {
        if (order.originalPrice == null) {
          order.originalPrice = order.price // store original on first interaction
        }
        const discount = this.selectedDiscount
        order.price = +(order.originalPrice * (1 - discount / 100)).toFixed(2)
      })
    },
    onDeliveryTypeSelect (value, order) {
      this.selecteDeliveryType = value
      order.deliveryType = value
      if (this.feedbackMessage) {
        this.setFeedbackMessage(this.$t(''))
      }
    },
    onOrderNumberView () {
      this.setFeedbackMessage(this.$t('ShortDispatch.reopen_window_alert'))
    },

    /** When the user wants to change the address, set the order with the @ref */
    onChangeAddress (order) {
      const delivRef = this.$refs.delivLocDetails

      delivRef.setOrder(order)
      this.isDelivLocModal = true
    },

    /** Updates the location of an order in the @arrOfOrder array after the user changes and saves the location in DeliveryLocationModal */
    async updateOrderLocation (updatedOrder, isApplyToAllTransmitter, isApplyToAllReceiver) {
      if (isApplyToAllTransmitter) { // If the user applies the location changes of an order to all orders in the array
        this.arrOfOrder.forEach(async order => {
          order.transmitterName = updatedOrder.transmitterName
          this.$set(order, 'realTransmitterName', updatedOrder.realTransmitterName || null)
          this.$set(order, 'differentTransmitter', updatedOrder.differentTransmitter || null)
          order.transmitterAddress = updatedOrder.transmitterAddress
          order.transmitterPostcode = updatedOrder.transmitterPostcode
          order.transmitterCity = updatedOrder.transmitterCity
          order.transmitterProvince = updatedOrder.transmitterProvince
          order.transmitterCountry = updatedOrder.transmitterCountry
          order.transmitterZone = updatedOrder.transmitterZone
          order.transmitterZoneId = updatedOrder.transmitterZoneId
          order.price = order.price
          await this.calculateTravelDistance(order)
        })
      }

      if (isApplyToAllReceiver) {
        this.arrOfOrder.forEach(async order => {
          order.receiverName = updatedOrder.receiverName
          this.$set(order, 'realReceiverName', updatedOrder.realReceiverName || null)
          this.$set(order, 'differentReceiver', updatedOrder.differentReceiver || null)
          order.receiverAddress = updatedOrder.receiverAddress
          order.receiverPostcode = updatedOrder.receiverPostcode
          order.receiverCity = updatedOrder.receiverCity
          order.receiverProvince = updatedOrder.receiverProvince
          order.receiverCountry = updatedOrder.receiverCountry
          order.receiverZone = updatedOrder.receiverZone
          order.receiverZoneId = updatedOrder.receiverZoneId
          order.price = order.price
          await this.calculateTravelDistance(order)
        })
      }

      let indexOfOrder = this.arrOfOrder.findIndex(originalOrder => (originalOrder.orderNumber || originalOrder['.key']) === updatedOrder.orderNumber || updatedOrder['.key'])
      this.$set(this.arrOfOrder, indexOfOrder, { ...updatedOrder })
      this.updateFinalData(this.arrOfOrder)
    },

    /** Updates the order in @arrOfOrder so the button in ShortDispatch gets updated for UX purposes */
    updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
      this.arrOfOrder.find((originalOrder, index) => {
        if (originalOrder.orderNumber === orderId) {
          this.arrOfOrder[index].historySync[historyKey] = updatedOrder
        }
        originalOrder.price = this.calculateMaxInputPrice(originalOrder)
      })
    },

    /** When @dropDate or @isCancelled doesn't exist in the last history key, allow the user to set the @dropDate or @isCancelled to the last history key */
    onChangeDropDate (order) {
      const distModalRef = this.$refs.distModal

      const keys = distModalRef.getObjectKeys(order.historySync)
      const lastKey = distModalRef.getLastArrayData(keys)

      distModalRef.setOrder(order)
      distModalRef.setOrderId(order.orderNumber)
      distModalRef.setHistoryKey(lastKey)

      this.isDistributedModal = true
    },

    /** Used to set the red (false) or green (true) buttons in Short Dispatch */
    checkHistory (history) {
      const isTruthy = this.$refs.distModal.checkHistory(history)
      return isTruthy
    },

    setFeedbackMessage (message) {
      this.feedbackMessage = message
    },

    onShortDispatchActionConfirm () {
      if (!this.dispatchOrder.chauffeurUid) { // Required driver selection
        this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.driver_not_selected_error'))
        return
      }

      let isDeliverySet = this.arrOfOrder.every((order, index) => {
        return order.hasOwnProperty('deliveryType') && order.deliveryType !== undefined
      })

      if (!isDeliverySet) {
        this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.delivery_type_not_selected_error'))
        return
      }
      if (!this.isDropDateFilled()) { // Drop date has to be filled (Green display, by setting a date or selecting "Cancelled order")
        this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.drop_date_error'))
        return
      }

      if (this.isBrunoAccount) { /** Make sure that the right @function isBrunoAccount() in @name main.js is always commented when deploying to live */
        if (!this.checkDispatchPrice()) return
      }

      this.shortDispatchAction({...this.dispatchOrder})
    },

    isDropDateFilled () {
      let isGucci = true

      this.arrOfOrder.forEach(order => {
        if (!this.checkHistory(order.historySync)) isGucci = false
      })

      return isGucci
    },

    async shortDispatchAction (driverData) {
      this.finalData.forEach(async (order, index) => {
        let orderNumber = order.orderNumber
        delete order.orderNumber
        if (!order.distance) {
          order.distance = await this.calculateTravelDistance(order)
        }
        // TODO: Do we want to save placeId/lat/long here?
        let dispatchOrder = {
          'chauffeur': driverData.chauffeurUid,
          'chauffeurName': driverData.chauffeurName,
          'nbDispatch': order.nbDispatch,
          'comment': order.comment,
          'numRef': order.numRef,
          'price': order.price || 0,
          'receiver': order.receiverName,
          'receiverAddress': order.receiverAddress,
          'receiverCity': order.receiverCity,
          'receiverContact': order.receiverContact,
          'receiverFax': order.receiverFax,
          'receiverName': order.receiverName,
          'receiverPhone': order.receiverPhone,
          'receiverEmail': order.receiverEmail || '',
          'receiverPostcode': order.receiverPostcode || '',
          'receiverProvince': order.receiverProvince || '',
          'receiverCountry': order.receiverCountry,
          'receiverZone': order.receiverZone || '',
          'transmitter': order.transmitterName,
          'transmitterAddress': order.transmitterAddress,
          'transmitterCity': order.transmitterCity,
          'transmitterContact': order.transmitterContact,
          'transmitterFax': order.transmitterFax,
          'transmitterName': order.transmitterName,
          'transmitterPhone': order.transmitterPhone,
          'transmitterEmail': order.transmitterEmail || '',
          'transmitterPostcode': order.transmitterPostcode || '',
          'transmitterProvince': order.transmitterProvince || '',
          'transmitterCountry': order.transmitterCountry || '',
          'transmitterZone': order.transmitterZone || '',
          'dateDispatch': this.getDate(Date.now()),
          'deliveryType': order.deliveryType,
          'distance': order.distance || 0,
          'deliveryOrder': index + 1
        }
        await this.dbPushSet(dispatchOrder, orderNumber)
      })

      this.clearSelected()
      this.reinitializeModal()
    },

    async dbPushSet (dispatchOrder, orderNumber) {
      await db.ref('test/transporter/' + this.companyUID + '/newDispatch/' + orderNumber).push().set(dispatchOrder)
      await this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_DISPATCH', 'orderID': orderNumber, 'date': Date.now()}) // ADD FAST DISPATCH LOG
      publishOrderSyncRequest(orderNumber, this.companyUID)
    },

    onOrderModification () {
      this.$emit('onOrderModification')
    },

    /** Calculates the price the user can input in the price field (Order price - all previous dispatch prices) */
    calculateMaxInputPrice (order) {
      let orderNumber = (order.orderNumber) ? order.orderNumber : order['.key']
      let currentOrder = this.priceOrderLink.find(obj => obj.orderId === orderNumber)

      const history = order.historySync || {}
      let orderMaxPrice = Number(currentOrder && currentOrder.price != null ? currentOrder.price : this.getPriceValue(order))

      if (order.priceTransfered) {
        orderMaxPrice = orderMaxPrice - Number(order.priceTransfered)
      }

      // Cycle through each delivery history and substract the price of each history to calculate the max input price possible
      for (const historyId in history) {
        if (Object.hasOwnProperty.call(history, historyId)) {
          const historyInfo = history[historyId]
          orderMaxPrice = orderMaxPrice - this.getPriceValue(historyInfo)
        }
      }

      if (isNaN(orderMaxPrice)) return '0.00'
      return orderMaxPrice.toFixed(2)
    },

    /** Validates if the entered price input is within the price of the order itself (Lower or equal to the order price) */
    checkDispatchPrice () {
      let index = 0
      let isAllGood = true
      let tempState = true

      this.arrOfOrder.forEach((order, i) => {
        tempState = this.evaluatePriceInput(this.arrOfOrder[index], order.price, this.priceOrderLink[index])
        // tempState = this.calculateMaxInputPrice(order)
        index += 1
        if (!tempState) isAllGood = false
      })

      return isAllGood
    },

    evaluatePriceInput (order, priceInput, maxPriceOrderLink) {
      let maxOrderId = maxPriceOrderLink.orderId
      const orderNumber = order.orderNumber

      if (orderNumber !== maxOrderId) {
        console.log('Error, order mismatch', order, orderNumber, maxOrderId)
        return
      }

      let maxPrice = this.calculateMaxInputPrice(order)
      priceInput = Number(parseFloat(priceInput).toFixed(2))

      if (priceInput === '' || isNaN(priceInput)) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-input')
        return false
      } else if (priceInput < 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-negative')
        return false
      } else if ((maxPrice === 0 || maxPrice === '' || typeof maxPrice === 'undefined') && priceInput <= 0) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/no-max-price')
        this.updateOrderPrice(order, priceInput, orderNumber) // Updates the order's price because we never actually touch the order's price
        return true
      } else if (priceInput > maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/too-high')
        return false
      } else if (priceInput !== '' && priceInput <= maxPrice) {
        this.setPriceOrderClass(orderNumber, maxPrice, 'price/perfect')
        this.updateOrderPrice(order, priceInput, orderNumber) // Updates the order's price because we never actually touch the order's price
        return true
      } else console.log('wtf', priceInput, maxPrice)
    },

    setPriceOrderClass (orderNumber, maxPrice, caseType) {
      switch (caseType) {
        case 'price/no-input':
          console.log('No price', orderNumber)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_price')
          break

        case 'price/no-negative':
          console.log('No negative price')
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.no_negative')
          break

        case 'price/too-high':
          console.log('Input is higher', maxPrice)
          document.getElementById('price' + orderNumber).className += ' red-border '
          this.feedbackMessage = this.$t('OrderCurrent.order') + ' #' + orderNumber + this.$t('OrderCurrent.modal.dispatch.too_high') + ' (Max: ' + (maxPrice || 0) + '$)'
          break

        case 'price/no-max-price':
          console.log('No max price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        case 'price/perfect':
          console.log('Good price', maxPrice)
          document.getElementById('price' + orderNumber).className += ' green-border '
          break

        default:
          break
      }
    },

    updateOrderPrice (updatedOrder, priceInput, orderNumber) {
      if (updatedOrder.orderNumber !== orderNumber) console.log('error')
      else {
        this.arrOfOrder.find((order, index) => {
          if (order.orderNumber === orderNumber) {
            this.arrOfOrder[index].price = priceInput
          }
        })
      }
    },

    calculateTravelDistance (order) {
      const originLat = order.transmitterLat
      const originLng = order.transmitterLong
      const destLat = order.receiverLat
      const destLng = order.receiverLong
      const mode = 'DRIVING'
      let google = this.google
      if (!google) return
      if (!originLat || !originLng || !destLat || !destLng) return
      return new Promise((resolve, reject) => {
        const directionsService = new google.maps.DirectionsService()

        const origin = new google.maps.LatLng(originLat, originLng)
        const destination = new google.maps.LatLng(destLat, destLng)

        const request = {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode[mode]
        }

        directionsService.route(request, (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            const route = result.routes[0]
            let totalDistance = 0

            for (let i = 0; i < route.legs.length; i++) {
              totalDistance += route.legs[i].distance.value
            }
            // Convert distance from meters to kilometers
            const distanceInKm = totalDistance / 1000
            order.distance = distanceInKm
            resolve(distanceInKm)
          } else if (status === google.maps.DirectionsStatus.ZERO_RESULTS) {
            resolve(0)
          } else {
            reject('Unable to calculate travel distance')
          }
        })
      })
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      else {
        let subString = text.substring(0, 22)
        if (text.length > 22) subString += '...'
        return subString
      }
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    reinitializeModal () {
      this.dispatchOrder.chauffeurUid = ''
      this.dispatchOrder.chauffeurName = ''
      this.feedbackMessage = ''

      this.closeModal()
    },

    clearSelected () {
      this.$emit('clearSelected')
    },
    closeModal () {
      this.$emit('closeModal')
    }
  },
  computed: {
    google: gmapApi,
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    }
  },
  watch: {
    arrOfOrder: {
      handler (newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.processOrders(newVal)
        }
      },
      immediate: false,
      deep: false
    },
    isDistributedModal: {
      handler (newVal) {
        this.reCalculateRecommendedPrice()
      }
    }
  }
}
</script>

<style scoped>
.short-dispatch-price-field {
  min-width: 85px;
}

  /* @media only screen and (max-width: 800px) {
    body {
      display: flex;
      flex-direction: column;
      color: red;
      background-color: red;
    }
  } */
</style>
